// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-document-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.view-document-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.view-document-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.view-document-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #1f2937;
  font-weight: 600;
}

.view-document-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  color: #6b7280;
  transition: all 0.2s;
}
.view-document-close-btn:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.view-document-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.view-document-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6b7280;
}
.view-document-loading .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;
}
.view-document-loading p {
  margin: 0;
  font-size: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.view-document-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6b7280;
  text-align: center;
}
.view-document-empty svg {
  margin-bottom: 16px;
  color: #d1d5db;
}
.view-document-empty h3 {
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  color: #374151;
  font-weight: 600;
}
.view-document-empty p {
  margin: 0;
  font-size: 0.95rem;
  color: #6b7280;
}

.view-document-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.view-document-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  background-color: #ffffff;
  transition: all 0.2s;
}
.view-document-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.view-document-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}
.view-document-card-header h3 {
  margin: 0;
  font-size: 1.125rem;
  color: #1f2937;
  font-weight: 600;
}

.view-document-status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #d1fae5;
  color: #065f46;
}

.view-document-card-info {
  margin-bottom: 16px;
}
.view-document-card-info p {
  margin: 8px 0;
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.5;
}
.view-document-card-info p strong {
  color: #1f2937;
  font-weight: 600;
}

.view-document-files {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.view-document-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 6px;
  transition: background-color 0.2s;
}
.view-document-file-item:hover {
  background-color: #f3f4f6;
}

.view-document-file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.view-document-file-icon {
  flex-shrink: 0;
  color: #3b82f6;
}

.view-document-file-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.view-document-file-name {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-document-file-type {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 2px;
}

.view-document-file-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.view-document-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.view-document-action-btn.view-btn {
  background-color: #3b82f6;
  color: white;
}
.view-document-action-btn.view-btn:hover {
  background-color: #2563eb;
}
.view-document-action-btn.download-btn {
  background-color: #10b981;
  color: white;
}
.view-document-action-btn.download-btn:hover {
  background-color: #059669;
}
.view-document-action-btn svg {
  flex-shrink: 0;
}

.view-document-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.view-document-close-footer-btn {
  padding: 10px 24px;
  background-color: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.view-document-close-footer-btn:hover {
  background-color: #4b5563;
}

@media (max-width: 768px) {
  .view-document-modal-content {
    width: 95%;
    max-height: 90vh;
  }
  .view-document-modal-header {
    padding: 16px;
  }
  .view-document-modal-header h2 {
    font-size: 1.25rem;
  }
  .view-document-modal-body {
    padding: 16px;
  }
  .view-document-card {
    padding: 16px;
  }
  .view-document-file-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .view-document-file-actions {
    width: 100%;
    justify-content: stretch;
  }
  .view-document-file-actions button {
    flex: 1 1;
  }
  .view-document-action-btn {
    justify-content: center;
  }
}
.upload-mode-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.upload-info-section h3 {
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  color: #1f2937;
  font-weight: 600;
}
.upload-info-section .upload-description {
  margin: 0;
  color: #6b7280;
  font-size: 0.95rem;
}

.upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  transition: all 0.2s;
  cursor: pointer;
}
.upload-area:hover {
  border-color: #3b82f6;
  background-color: #f9fafb;
}
.upload-area .upload-label {
  cursor: pointer;
  display: block;
  width: 100%;
}
.upload-area .upload-icon-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.upload-area .upload-icon-area p {
  margin: 0;
  font-size: 1rem;
  color: #1f2937;
  font-weight: 500;
}
.upload-area .upload-icon-area small {
  color: #6b7280;
  font-size: 0.85rem;
}

.uploading-files-section h4 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  color: #1f2937;
  font-weight: 600;
}

.upload-progress-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.upload-progress-item .progress-bar-container {
  flex: 1 1;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}
.upload-progress-item .progress-bar-container .progress-bar-fill {
  height: 100%;
  background-color: #3b82f6;
  transition: width 0.3s ease;
}
.upload-progress-item .progress-text {
  font-size: 0.875rem;
  color: #6b7280;
  min-width: 45px;
  text-align: right;
}

.uploaded-files-section h4 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  color: #1f2937;
  font-weight: 600;
}

.uploaded-files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.uploaded-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}
.uploaded-file-item .file-item-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}
.uploaded-file-item .file-item-info .file-name {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.uploaded-file-item .file-item-info .existing-badge {
  padding: 2px 8px;
  background-color: #dbeafe;
  color: #1e40af;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}
.uploaded-file-item .file-item-actions {
  display: flex;
  gap: 8px;
}
.uploaded-file-item .file-item-actions button {
  padding: 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.uploaded-file-item .file-item-actions button.view-file-btn {
  background-color: #3b82f6;
  color: white;
}
.uploaded-file-item .file-item-actions button.view-file-btn:hover {
  background-color: #2563eb;
}
.uploaded-file-item .file-item-actions button.remove-file-btn {
  background-color: #ef4444;
  color: white;
}
.uploaded-file-item .file-item-actions button.remove-file-btn:hover {
  background-color: #dc2626;
}

.no-files-message {
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
}
.no-files-message p {
  margin: 0;
  font-size: 0.95rem;
}

.view-document-submit-btn {
  padding: 10px 24px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.view-document-submit-btn:hover:not(:disabled) {
  background-color: #2563eb;
}
.view-document-submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.view-document-cancel-btn {
  padding: 10px 24px;
  background-color: #e5e7eb;
  color: #1f2937;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.view-document-cancel-btn:hover:not(:disabled) {
  background-color: #d1d5db;
}
.view-document-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/ViewDocumentModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,gCAAA;AAAF;;AAGA;EACE;IACE,2BAAA;IACA,UAAA;EAAF;EAEA;IACE,wBAAA;IACA,UAAA;EAAF;AACF;AAGA;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;AAGE;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AAFF;AAIE;EACE,yBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AAHF;AAKE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;AAHJ;AAME;EACE,SAAA;EACA,eAAA;AAJJ;;AAQA;EACE;IACE,yBAAA;EALF;AACF;AAQA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AANF;AAQE;EACE,mBAAA;EACA,cAAA;AANJ;AASE;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAPJ;AAUE;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;AATF;AAWE;EACE,0CAAA;AATJ;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAVF;AAYE;EACE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAVJ;;AAcA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;AAaE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAXJ;AAaI;EACE,cAAA;EACA,gBAAA;AAXN;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAbF;;AAgBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;AAbF;AAeE;EACE,yBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AAdF;;AAiBA;EACE,cAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAdF;;AAiBA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAdF;AAgBE;EACE,yBAAA;EACA,YAAA;AAdJ;AAgBI;EACE,yBAAA;AAdN;AAkBE;EACE,yBAAA;EACA,YAAA;AAhBJ;AAkBI;EACE,yBAAA;AAhBN;AAoBE;EACE,cAAA;AAlBJ;;AAsBA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAnBF;AAqBE;EACE,yBAAA;AAnBJ;;AAwBA;EACE;IACE,UAAA;IACA,gBAAA;EArBF;EAwBA;IACE,aAAA;EAtBF;EAwBE;IACE,kBAAA;EAtBJ;EA0BA;IACE,aAAA;EAxBF;EA2BA;IACE,aAAA;EAzBF;EA4BA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EA1BF;EA6BA;IACE,WAAA;IACA,wBAAA;EA3BF;EA6BE;IACE,SAAA;EA3BJ;EA+BA;IACE,uBAAA;EA7BF;AACF;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/BF;;AAmCE;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAhCJ;AAmCE;EACE,SAAA;EACA,cAAA;EACA,kBAAA;AAjCJ;;AAqCA;EACE,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAlCF;AAoCE;EACE,qBAAA;EACA,yBAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,cAAA;EACA,WAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AApCJ;AAsCI;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AApCN;AAuCI;EACE,cAAA;EACA,kBAAA;AArCN;;AA2CE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAxCJ;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAzCF;AA2CE;EACE,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAzCJ;AA2CI;EACE,YAAA;EACA,yBAAA;EACA,2BAAA;AAzCN;AA6CE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA3CJ;;AAgDE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA7CJ;;AAiDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AA9CF;AAgDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AA9CJ;AAgDI;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9CN;AAiDI;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA/CN;AAmDE;EACE,aAAA;EACA,QAAA;AAjDJ;AAmDI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAjDN;AAmDM;EACE,yBAAA;EACA,YAAA;AAjDR;AAmDQ;EACE,yBAAA;AAjDV;AAqDM;EACE,yBAAA;EACA,YAAA;AAnDR;AAqDQ;EACE,yBAAA;AAnDV;;AA0DA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAvDF;AAyDE;EACE,SAAA;EACA,kBAAA;AAvDJ;;AA2DA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAxDF;AA0DE;EACE,yBAAA;AAxDJ;AA2DE;EACE,yBAAA;EACA,mBAAA;AAzDJ;;AA6DA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AA1DF;AA4DE;EACE,yBAAA;AA1DJ;AA6DE;EACE,YAAA;EACA,mBAAA;AA3DJ","sourcesContent":[".view-document-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.2s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.view-document-modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 900px;\r\n  max-height: 85vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\r\n  animation: slideUp 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(30px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.view-document-modal-header {\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n\r\n  h2 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    color: #1f2937;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.view-document-close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 8px;\r\n  border-radius: 6px;\r\n  color: #6b7280;\r\n  transition: all 0.2s;\r\n\r\n  &:hover {\r\n    background-color: #f3f4f6;\r\n    color: #1f2937;\r\n  }\r\n}\r\n\r\n.view-document-modal-body {\r\n  padding: 24px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.view-document-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n  color: #6b7280;\r\n\r\n  .spinner {\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 3px solid #e5e7eb;\r\n    border-top-color: #3b82f6;\r\n    border-radius: 50%;\r\n    animation: spin 0.8s linear infinite;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.view-document-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n  color: #6b7280;\r\n  text-align: center;\r\n\r\n  svg {\r\n    margin-bottom: 16px;\r\n    color: #d1d5db;\r\n  }\r\n\r\n  h3 {\r\n    margin: 0 0 8px 0;\r\n    font-size: 1.25rem;\r\n    color: #374151;\r\n    font-weight: 600;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n    color: #6b7280;\r\n  }\r\n}\r\n\r\n.view-document-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.view-document-card {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  background-color: #ffffff;\r\n  transition: all 0.2s;\r\n\r\n  &:hover {\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  }\r\n}\r\n\r\n.view-document-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n\r\n  h3 {\r\n    margin: 0;\r\n    font-size: 1.125rem;\r\n    color: #1f2937;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.view-document-status-badge {\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  background-color: #d1fae5;\r\n  color: #065f46;\r\n}\r\n\r\n.view-document-card-info {\r\n  margin-bottom: 16px;\r\n\r\n  p {\r\n    margin: 8px 0;\r\n    font-size: 0.9rem;\r\n    color: #4b5563;\r\n    line-height: 1.5;\r\n\r\n    strong {\r\n      color: #1f2937;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n}\r\n\r\n.view-document-files {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.view-document-file-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px;\r\n  background-color: #f9fafb;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n\r\n  &:hover {\r\n    background-color: #f3f4f6;\r\n  }\r\n}\r\n\r\n.view-document-file-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.view-document-file-icon {\r\n  flex-shrink: 0;\r\n  color: #3b82f6;\r\n}\r\n\r\n.view-document-file-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.view-document-file-name {\r\n  font-size: 0.9rem;\r\n  color: #1f2937;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.view-document-file-type {\r\n  font-size: 0.75rem;\r\n  color: #6b7280;\r\n  margin-top: 2px;\r\n}\r\n\r\n.view-document-file-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.view-document-action-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 14px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n\r\n  &.view-btn {\r\n    background-color: #3b82f6;\r\n    color: white;\r\n\r\n    &:hover {\r\n      background-color: #2563eb;\r\n    }\r\n  }\r\n\r\n  &.download-btn {\r\n    background-color: #10b981;\r\n    color: white;\r\n\r\n    &:hover {\r\n      background-color: #059669;\r\n    }\r\n  }\r\n\r\n  svg {\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n.view-document-modal-footer {\r\n  padding: 16px 24px;\r\n  border-top: 1px solid #e5e7eb;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n.view-document-close-footer-btn {\r\n  padding: 10px 24px;\r\n  background-color: #6b7280;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n\r\n  &:hover {\r\n    background-color: #4b5563;\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .view-document-modal-content {\r\n    width: 95%;\r\n    max-height: 90vh;\r\n  }\r\n\r\n  .view-document-modal-header {\r\n    padding: 16px;\r\n\r\n    h2 {\r\n      font-size: 1.25rem;\r\n    }\r\n  }\r\n\r\n  .view-document-modal-body {\r\n    padding: 16px;\r\n  }\r\n\r\n  .view-document-card {\r\n    padding: 16px;\r\n  }\r\n\r\n  .view-document-file-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .view-document-file-actions {\r\n    width: 100%;\r\n    justify-content: stretch;\r\n\r\n    button {\r\n      flex: 1;\r\n    }\r\n  }\r\n\r\n  .view-document-action-btn {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n// Upload Mode Styles\r\n.upload-mode-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.upload-info-section {\r\n  h3 {\r\n    margin: 0 0 8px 0;\r\n    font-size: 1.25rem;\r\n    color: #1f2937;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .upload-description {\r\n    margin: 0;\r\n    color: #6b7280;\r\n    font-size: 0.95rem;\r\n  }\r\n}\r\n\r\n.upload-area {\r\n  border: 2px dashed #d1d5db;\r\n  border-radius: 8px;\r\n  padding: 40px 20px;\r\n  text-align: center;\r\n  transition: all 0.2s;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    border-color: #3b82f6;\r\n    background-color: #f9fafb;\r\n  }\r\n\r\n  .upload-label {\r\n    cursor: pointer;\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .upload-icon-area {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 12px;\r\n\r\n    p {\r\n      margin: 0;\r\n      font-size: 1rem;\r\n      color: #1f2937;\r\n      font-weight: 500;\r\n    }\r\n\r\n    small {\r\n      color: #6b7280;\r\n      font-size: 0.85rem;\r\n    }\r\n  }\r\n}\r\n\r\n.uploading-files-section {\r\n  h4 {\r\n    margin: 0 0 12px 0;\r\n    font-size: 1rem;\r\n    color: #1f2937;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.upload-progress-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n\r\n  .progress-bar-container {\r\n    flex: 1;\r\n    height: 8px;\r\n    background-color: #e5e7eb;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n\r\n    .progress-bar-fill {\r\n      height: 100%;\r\n      background-color: #3b82f6;\r\n      transition: width 0.3s ease;\r\n    }\r\n  }\r\n\r\n  .progress-text {\r\n    font-size: 0.875rem;\r\n    color: #6b7280;\r\n    min-width: 45px;\r\n    text-align: right;\r\n  }\r\n}\r\n\r\n.uploaded-files-section {\r\n  h4 {\r\n    margin: 0 0 12px 0;\r\n    font-size: 1rem;\r\n    color: #1f2937;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.uploaded-files-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.uploaded-file-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px;\r\n  background-color: #f9fafb;\r\n  border-radius: 6px;\r\n  border: 1px solid #e5e7eb;\r\n\r\n  .file-item-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    .file-name {\r\n      font-size: 0.9rem;\r\n      color: #1f2937;\r\n      font-weight: 500;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n\r\n    .existing-badge {\r\n      padding: 2px 8px;\r\n      background-color: #dbeafe;\r\n      color: #1e40af;\r\n      border-radius: 12px;\r\n      font-size: 0.75rem;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  .file-item-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n\r\n    button {\r\n      padding: 6px;\r\n      border: none;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transition: all 0.2s;\r\n\r\n      &.view-file-btn {\r\n        background-color: #3b82f6;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #2563eb;\r\n        }\r\n      }\r\n\r\n      &.remove-file-btn {\r\n        background-color: #ef4444;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #dc2626;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.no-files-message {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  color: #6b7280;\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n  }\r\n}\r\n\r\n.view-document-submit-btn {\r\n  padding: 10px 24px;\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: #2563eb;\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #9ca3af;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n.view-document-cancel-btn {\r\n  padding: 10px 24px;\r\n  background-color: #e5e7eb;\r\n  color: #1f2937;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: #d1d5db;\r\n  }\r\n\r\n  &:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
